const appenv = {
  development: {
    apiUrl: "http://localhost:7076/api",
  },
  test: {
    apiUrl: "https://itsybitsylist-api.azurewebsites.net",
  },
  production: {
    apiUrl: "https://wishlistfunctionapi.azurewebsites.net/api",
  },
};

export default appenv;
